// extracted by mini-css-extract-plugin
export default {"container":"payment_container__Gdm3F"};